import { dataService } from '../../data';

import { DataObject, ObjectOptions, RelatedObject } from "../base";
import { CreateObject } from "../item";
import { QrCode } from './qrcode';
import { Extra } from './extra';

/****************************/
/* SCHEMA DEFINITION        */
/****************************/

import { ExtraType } from '../types';
import { QrCodeType } from '../types';

const _schema = {
    "name": "EXTRATABLE",
    "fields": [
        { name: "status", type: "string", default: "AC" },
        { name: "extra", type: "objid" },
        { name: "qrcode", type: "objid" }
    ],
    relate: [
        { direction: ">", target: "EXTRA", by: "extra", name: "extra", reason: "extra", child: false, class: ExtraType },
        { direction: ">", target: "QRCODE", by: "qrcode", name: "qrcode", reason: "qrcode", child: false, class: QrCodeType }
    ]
} as const;

const _ExtraTableClass = CreateObject(_schema);
if (!_ExtraTableClass) {
    throw new Error("Failed to create BaseClass for '" + _schema.name + "'");
}

/****************************/
/* CLASS DECLARATION        */
/****************************/

export class ExtraTable extends _ExtraTableClass { 
    constructor(objid: string | null, data: dataService, objoptions: ObjectOptions | null = null){
        super(_schema, objid, data, objoptions || {});
    }

    Copy(store: Array<DataObject> = []): ExtraTable {
        return this._Copy(store) as ExtraTable;
    }

    protected override DoChildLinked(relation: string | null, related: RelatedObject | null): void {
        if (this.CopyOf || !this.Commited){
            return;
        }

        if (relation === 'extra' && related instanceof Extra){
            if (related === this.extra){
                related.AddQrcode(this);
            }
            return;
        }

        if (relation === 'qrcode' && related instanceof QrCode){
            if (related === this.qrcode){
                related.AddExtra(this);
            }
        }
    }

    /****************************/
    /* CLASS MEMBERS            */
    /****************************/

    get status(): string | null {
        return this['__base__status']
    }

    set status(value: string){
        if (this.status == 'DE'){
            return;     // cannot modify deleted items
        }

        if (this.status == value){
            return;
        }

        this['__base__status'] = value;
        if (this.extra){
            if ((this.status == 'DE') && !this.Commited){
                this.extra.DelQrcode(this);
            }
            else {
                this.extra.DoRefresh(this.table);
            }    
        }
    }

    /****************************/
    /* CUSTOM METHODS           */
    /****************************/

    get IsValid(): boolean {
        return (!!this.status && (this.status != 'DE'));
    }
}

